import { Box } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../components/TableContent';

import { DividendHistoryItemTypes } from './types';

export const DividendHistoryItemTablet: React.FC<DividendHistoryItemTypes.Props> = ({ item }) => {
  const itemData = [
    [
      {
        label: 'Tipo',
        value: item.dividendType,
      },
      {
        label: 'Empresa',
        value: item.companyName,
      },
      {
        label: 'ISIN',
        value: item.isinCode,
      },
      {
        label: 'Cód. Neg.',
        value: item.negotiationCode,
      },
      {
        label: 'Ativo',
        value: item.assetName,
      },
    ],
    [
      {
        label: 'Valor',
        value: item.assetValueNormalized,
      },
      {
        label: 'Aprovação',
        value: item.approvalDateNormalized,
      },
      {
        label: 'Início',
        value: item.startDateNormalized,
      },
      {
        label: 'Atualização',
        value: item.updateDateNormalized,
      },
      {
        label: 'Prazo Final',
        value: item.dueDateNormalized,
      },
    ],
  ];

  const itemContent = itemData.map((row, rowIndex) => {
    const rowContent = row.map((col, colIndex) => {
      return (
        <TableContentItemColumn key={`${rowIndex}-${colIndex}`} flex={1}>
          <TableContentItemText variant="semibold">{col.label}</TableContentItemText>
          <TableContentItemText>{col.value}</TableContentItemText>
        </TableContentItemColumn>
      );
    });

    return (
      <Box flexDirection="row" width="full" key={rowIndex}>
        {rowContent}
      </Box>
    );
  });

  itemContent.splice(
    1,
    0,
    <Box
      key="spacer"
      borderBottomColor="neutral.lightest"
      borderBottomWidth="1px"
      paddingTop="inset.xs"
      marginBottom="inset.xs"
      width="full"
    />
  );

  return (
    <TableContent direction="column" space={0} py="stack.xxs" px="inline.xxxs" spaceX="inline.xxxs">
      {itemContent}
    </TableContent>
  );
};
